import Vue from 'vue';
import '@/less/main.less';
import Router from 'vue-router';
import router from './router';
import App from './App.vue';
import { initReport } from '@tencent/ppd-base-libs';
import 'swiper/swiper-bundle.css';
import i18n from '@/language/index';
// core version + navigation, pagination modules:
import SwiperCore, { Mousewheel, Keyboard, Pagination, Autoplay } from 'swiper/core';
// 新版本swiper支持按模块引入
// configure Swiper to use modules
SwiperCore.use([Mousewheel, Keyboard, Pagination, Autoplay]);

// 数据上报初始化
initReport({
  appEnv: process.env.VUE_APP_ENV,
  business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
  isReportPageStayedTime: true, // 是否上报页面停留时间
  sentry: {
    dsn: 'https://a078a7a7b7fd494fb92700d5eac546fe@report.url.cn/sentry/3434',
    // webpack变异全局变量
    release: process.env.VUE_APP_SENTRY_VERSION,
  },
  bi: {
    reportNeedLogin: false,
    sid: '500735886',
    cid: '500735887',
    domain: 'weremit.tenpay.com',
  },
}, Vue);

// 处理路由信息
Vue.use(Router);

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
